import clsx from "clsx";
import { Footer } from "./Footer";

export function IconExclamationTriangle(props: React.ComponentPropsWithoutRef<"svg">) {
  return (
    <svg viewBox='0 0 24 24' {...props} className={clsx("tw-top-0.125", props.className)}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.636 3.258c1.066-1.793 3.662-1.793 4.728 0l7.484 12.586c1.09 1.833-.232 4.156-2.364 4.156H4.516c-2.133 0-3.454-2.323-2.364-4.156zM12 8a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 12 8m1 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0'
      />
    </svg>
  );
}

export function Error({ children }: { children: string | null }) {
  return (
    <Footer color='red' icon={IconExclamationTriangle}>
      {children}
    </Footer>
  );
}
